import React from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { useAtom } from "jotai";
import { promptAtom } from "../support/atoms";

const Popup = () => {
  const [prompt] = useAtom(promptAtom);

  return (
    <Dialog
      open={prompt.isOpen ? true : false}
      fullWidth
      maxWidth={prompt.maxWidth}
      PaperProps={{ sx: { width: { xs: "100vh" }, margin: 1 } }}
    >
      <DialogTitle id="alert-dialog-title">{prompt.title}</DialogTitle>
      <DialogContent sx={{ padding: { xs: 1, sm: 3 } }}>
        {prompt.component}
      </DialogContent>
    </Dialog>
  );
};

export default Popup;
